module.exports = __webpack_public_path__ + "static/media/video-2.e781992c.webm";


//////////////////
// WEBPACK FOOTER
// ./src/videos/video-2.webm
// module id = 155
// module chunks = 0